import React, { FC } from 'react';
import ContactFormTemplate from '@components/ContactForm/ContactForm';
import useTranslation from '@hooks/useTranslation';
import { publicAssets } from '@utils/url.utils';
import ContentWrapper from '../../ui/Content/Content';
import {
    ContactPerson,
    ContactPersonDescription,
    ContactPersonImage,
    ContactPersonLabel,
    ContactPersonName,
    ContactPersonPhone,
    Wrapper,
} from './RentSuport.elements';

interface RentSupportProps { }

const RentSupportTemplate: FC<RentSupportProps> = () => {
    const { t } = useTranslation();

    return (
        <ContentWrapper>
            <Wrapper>
                <ContactFormTemplate withoutBackground />
                <ContactPerson>
                    <ContactPersonLabel>{t('classroomRent.support.person.label')}</ContactPersonLabel>
                    <ContactPersonImage src={publicAssets('/a_zizka.webp')} />
                    <ContactPersonName>Alexandra Žižka</ContactPersonName>
                    <ContactPersonDescription dangerouslySetInnerHTML={{ __html: t('classroomRent.support.person.description') }} />
                    <ContactPersonPhone>+420 739 213 778</ContactPersonPhone>
                </ContactPerson>
            </Wrapper>
        </ContentWrapper>
    );
};
export default RentSupportTemplate;
